import React from 'react';
import { connect } from 'react-redux';
import resolvePath from '../../misc/resolvePath';
import EventTime from '../elements/EventTime';
import Hint from '../elements/Hint';
import Link from '../elements/Link';
import ListItem from '../elements/DEPRECATED_ListItem';
import Scrollable from '../elements/Scrollable';
import TopBarEvent from '../elements/TopBar/TopBarEvent';
import LoadProgram from '../loaders/LoadProgram';
import WaitWhileBusy from '../WaitWhileBusy';
import Screen from './Screen';

class EventCreateMeeting extends React.Component {
    render() {
        let {event, i18n, speeddates} = this.props;

        let header = (
                <div>
                    <TopBarEvent event={event} meetings={true} />
                    <Hint>{i18n['label.appointment-explainer']}</Hint>
                    <hr />
                </div>
            ),
            options = [
                // TODO: add post a quest option
                // TODO: add "Search the participants list option"
                _(speeddates)
                    .values()
                    .map(item => {
                        let itemProps = {
                            icon: 'img/speeddate_icon.png',
                            iconColor: event.settings.secondary_color,
                            iconStyle: {left: 25, top: 10},
                            iconSize: 25,
                        };
                        return (
                            <ListItem className="item" {...itemProps} key={`speeddate-${item.id}`} next>
                                <Link href={['/events', event.id, 'meetings', 'create', 'speeddate', item.id].join('/')}>
                                    <div className="text name">{item.name}</div>
                                    <div className="text time">
                                        <EventTime event={event} time={item.start_local} />
                                        &nbsp;-&nbsp;
                                        <EventTime event={event} time={item.end_local} />
                                    </div>
                                </Link>
                            </ListItem>
                        );
                    })
                    .value(),
            ];

        return (
            <Screen header={header}>
                <Scrollable>
                    <ul className="list">
                        <ListItem
                            className="item"
                            icon="img/event_participants.png"
                            iconColor={event.settings.secondary_color}
                            iconStyle={{
                                left: 25,
                                top: 20,
                            }}
                            iconSize={25}
                            next="next">
                            <Link href={resolvePath('/events', event.id.toString(), 'meetings', 'create', 'participants')}>
                                <div className="text name">{i18n['button.appointment-via-participants']}</div>
                                <p>{i18n['description.appointment-via-participants']}</p>
                            </Link>
                        </ListItem>
                        {options}
                    </ul>
                </Scrollable>
            </Screen>
        );
    }
}

const EventCreateMeetingConnected = connect((state, props) => {
    return {
        event: state.events[props.eventId].event,
        speeddates: state.events[props.eventId].schedule.speeddates,
        i18n: state.i18n.translations,
    };
})(EventCreateMeeting);

export default props => (
    <LoadProgram eventId={props.match.params.eventId}>
        <WaitWhileBusy>
            <EventCreateMeetingConnected {...props.match.params} />
        </WaitWhileBusy>
    </LoadProgram>
);
